import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=241ebd5c&scoped=true"
import script from "./DashboardTabs.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.vue?vue&type=script&lang=js"
import style0 from "./DashboardTabs.vue?vue&type=style&index=0&id=241ebd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ebd5c",
  null
  
)

export default component.exports